import React, { useState } from 'react';
import { Button, Input } from 'edozvola-frontend-lib/dist/ui/components';
import InterventionTable from 'app/edozvola/cases/construction-building-procedure/interventions/intervention-table';
import InterventionForm from 'app/edozvola/cases/construction-building-procedure/interventions/intervention-form';
import { copyInterventionsFromCaseQuery } from 'app/edozvola/cases/construction-building-procedure/service/construction-building-procedure.queries';
import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { caseWebIdToCopyFromSchema } from 'app/edozvola/cases/construction-building-procedure/construction-building-procedure.schema';
import { CASE_TAB_ENUM } from 'app/config/constants';
import InterventionFormV2 from 'app/edozvola/cases/construction-building-procedure/interventions/intervention-form-v2';
import { Col, Label, Row } from 'reactstrap';
import { PaginatedDropdown } from 'edozvola-frontend-lib/dist/ui/components/paginated-dropdown/PaginatedDropdown';
import { getCaseContext } from 'app/shared/util/context-util';

const Interventions = ({
  variant,
  procedureNumberOptions,
  setProcedureNumberOption,
  procedureNumberIsLoading,
  selectedProcedureNumberOption,
  formik,
}) => {
  const { id: uuid } = useParams<{ id: string }>();
  const [idIntervention, setIdIntervention] = useState<string | null>(null);
  const [readOnly, setReadOnly] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const copyInterventionsFormik = useFormik({
    initialValues: { caseWebIdToCopyFrom: '' },
    validationSchema: caseWebIdToCopyFromSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: values => copyInterventions(values.caseWebIdToCopyFrom),
  });

  const { mutate: copyInterventions, isPending: isCopyInterventionsPending } = copyInterventionsFromCaseQuery(
    uuid,
    variant,
    copyInterventionsFormik.resetForm,
  );

  const openInterventionForm = () => {
    setIdIntervention('');
    setReadOnly(false);
  };

  return (
    <>
      <h6 className="form-header mb-0">Zahvat</h6>
      <div className={'pt-4 pb-4'}>
        <Row>
          <Col md={5}>
            <Label labelText={'Broj zahvata'} />
            <PaginatedDropdown
              placeholder={!sidebarItemPair?.readOnly && 'Odaberi broj zahvata'}
              onItemSelect={setProcedureNumberOption}
              selected={selectedProcedureNumberOption}
              labelKey={'value'}
              options={procedureNumberOptions ?? []}
              disabled={sidebarItemPair?.readOnly}
              error={!sidebarItemPair?.readOnly && ((formik.errors.procedureNumber as string) ?? '')}
              showErrorMessage
              clearButton
            />
          </Col>
        </Row>
      </div>
      {!sidebarItemPair?.readOnly && (
        <div className={'d-flex justify-content-end pb-4 gap-2'}>
          <div className="case-copy-from-other-case">
            <Input
              placeholder={'Unesite šifru predmeta'}
              maxLength={255}
              addonAppend={
                isCopyInterventionsPending ? (
                  <FontAwesomeIcon icon="spinner" spin />
                ) : (
                  <FontAwesomeIcon
                    aria-disabled={
                      (!!copyInterventionsFormik.errors && !!copyInterventionsFormik.errors.caseWebIdToCopyFrom) ||
                      copyInterventionsFormik.values.caseWebIdToCopyFrom === ''
                    }
                    className={
                      (!!copyInterventionsFormik.errors && !!copyInterventionsFormik.errors.caseWebIdToCopyFrom) ||
                      copyInterventionsFormik.values.caseWebIdToCopyFrom === ''
                        ? 'disabled'
                        : ''
                    }
                    icon="copy"
                  />
                )
              }
              value={copyInterventionsFormik.values.caseWebIdToCopyFrom}
              onChange={event => {
                copyInterventionsFormik.setFieldValue('caseWebIdToCopyFrom', event.target.value);

                if (copyInterventionsFormik.submitCount > 0) {
                  copyInterventionsFormik.setErrors({});
                }
              }}
              addonAppendClick={() => {
                if (!isCopyInterventionsPending) {
                  copyInterventionsFormik.handleSubmit();
                }
              }}
              error={
                copyInterventionsFormik.errors && copyInterventionsFormik.errors.caseWebIdToCopyFrom
                  ? copyInterventionsFormik.errors.caseWebIdToCopyFrom
                  : ''
              }
            />
          </div>
          <div>
            <Button label={'Dodaj zahvat'} color={'info'} prependIcon={'plus'} size={'lg'} onClick={openInterventionForm} />
          </div>
        </div>
      )}
      <InterventionTable setIdIntervention={setIdIntervention} setReadOnly={setReadOnly} variant={variant} />
      {idIntervention !== null && (
        <>
          {variant === CASE_TAB_ENUM.CONSTRUCTION_BUILDING_PROCEDURE && (
            <InterventionForm
              readOnly={readOnly}
              setIdIntervention={setIdIntervention}
              idIntervention={idIntervention}
              variant={CASE_TAB_ENUM.CONSTRUCTION_BUILDING_PROCEDURE}
            />
          )}
          {variant === CASE_TAB_ENUM.CONSTRUCTION_BUILDING_PROCEDURE_V2 && (
            <InterventionFormV2
              readOnly={readOnly}
              setIdIntervention={setIdIntervention}
              idIntervention={idIntervention}
              variant={CASE_TAB_ENUM.CONSTRUCTION_BUILDING_PROCEDURE_V2}
            />
          )}
        </>
      )}
    </>
  );
};

export default Interventions;
